import { render, staticRenderFns } from "./DuoListBox.vue?vue&type=template&id=0405fbe6&scoped=true&"
import script from "./DuoListBox.vue?vue&type=script&lang=js&"
export * from "./DuoListBox.vue?vue&type=script&lang=js&"
import style0 from "./DuoListBox.vue?vue&type=style&index=0&id=0405fbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0405fbe6",
  null
  
)

export default component.exports